@let q = question();
<h3>{{ q.title }}</h3>
@if (q.subtitle) {
  <p>{{ q.subtitle }}</p>
}
<div [formGroup]="form" class="grid">
  @for (option of q.options; track option.id) {
    <div class="grid-element">
      <input
        type="checkbox"
        [checked]="form.get('consent')?.value.includes(option.id)"
        (change)="toggleOption(option.id)"
        [id]="q.id + ' ' + option"
      />
      <label [for]="q.id + ' ' + option.id">{{ option.label }}</label>
    </div>
  }
</div>
